import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UCMe } from './selvbetjening.types';

@Injectable({
  providedIn: 'root'
})
export class SelvbetjeningService {
  rootUrl = 'https://appgw.prod.iktest.co/api-app/utilitycloud';

  constructor(private _httpClient: HttpClient) {}

  updateDueDate(erpId: string, dueDate: string): Observable<any> {
    return this._httpClient.post(
      `${this.rootUrl}/duedate/${erpId}/${dueDate}`,
      {}
    );
  }

  updateContact(payload: string): Observable<any> {
    return this._httpClient.patch(`${this.rootUrl}/account/update`, payload);
  }

  getContact(): Observable<UCMe> {
    return this._httpClient.get<UCMe>(`${this.rootUrl}/me`);
  }
}
